<div class="container-fluid">
	<br>
	<section>
		<nav>
			<ul class="nav nav-tabs">
				<li class="nav-item pe-1">
					<a [routerLinkActive]="['active']" [routerLink]="['number-traits']" class="nav-link" data-test="numberTraitsTab"
					   jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.number.traits.title" queryParamsHandling="merge"></a>
				</li>
				<li class="nav-item pe-1">
					<a [routerLinkActive]="['active']" [routerLink]="['character-traits']" class="nav-link" data-test="characterTraitsTab"
					   jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.character.traits.title" queryParamsHandling="merge"></a>
				</li>
				<li class="nav-item pe-1">
					<a [routerLinkActive]="['active']" [routerLink]="['categorical-traits']" class="nav-link" data-test="categoricalTraitsTab"
					   jhiTranslate="multi-trait-query.panel.setup.the.trait.filter.panel.categorical.traits.title" queryParamsHandling="merge"></a>
				</li>
			</ul>
		</nav>
		<div class="tab-content p-3">
			<router-outlet></router-outlet>
		</div>
	</section>
	<br>
	<div class="row">
		<div class="col-md-12 align-center">
			<button (click)="onBack()" class="btn btn-secondary ms-2" jhiTranslate="back"></button>
			<button (click)="onNext()" [disabled]="isNextDisable()" class="btn btn-primary ms-2" jhiTranslate="next"></button>
		</div>
	</div>
</div>